export default __webpack_public_path__ + "static/media/tasks-icon.c15f2797.png";